const CategoryProductAhan = [
    {
        ID: -1 , 
        ParentID: "",
        Name: " همه موارد",
    },
    {
        ID: 2001 , 
        ParentID: "",
        Name: " پروفیل ",
    },
    {
        ID: 2002 , 
        ParentID: "",
        Name: " نبشی ",
    },
    {
        ID: 2003 , 
        ParentID: "",
        Name: " تیرآهن ",
    },
    {
        ID: 2004 , 
        ParentID: "",
        Name: " میلگرد ",
    },
    {
        ID: 2005 , 
        ParentID: "",
        Name: " ورق استنلس استیل ",
    },
    {
        ID: 2006 , 
        ParentID: "",
        Name: " ورق ",
    },
    {
        ID: 2007 , 
        ParentID: "",
        Name: " لوله ",
    },
    {
        ID: 2008 , 
        ParentID: "",
        Name: " محصولات مفتولی ",
    },
]
export default CategoryProductAhan;